<template>
  <div :class="['footer', { 'studio-7': !isBnn }]">
    {{ text }}
  </div>
</template>

<script>
import moment from 'moment'
import isBnn from '@/config/isBnn'

export default {
  data() {
    return {
      isBnn,
    }
  },
  computed: {
    text() {
      return `Copyright ©${moment().format(
        'YYYY',
      )}  Com7 Public Company Limited
            All Rights Reserved.`
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer
    background: transparent
    color: black
    font-weight: normal
    font-size: 10px
    border-top: 1px solid $color-gray85
    height: fit-content
    padding 16px
    color: rgba(18, 18, 18, .75);
    text-align: center;
    font-size: .6875rem;
    font-weight: 400;
    letter-spacing: .7px;

.footer.studio-7
    background: white
    color: black
    font-weight: normal
    font-size: 10px
    border-top: 1px solid $color-gray85
    height: fit-content
    padding 16px
    color: rgba(18, 18, 18, .75);
    text-align: center;
    font-size: .6875rem;
    font-weight: 400;
    letter-spacing: .7px;
</style>
